<ng-container>
    <h2 mat-dialog-title class="dialog-header">
        <span class="dialog-title title-large">{{ 'customers.ui.filtri' | transloco }}</span>

        <button
            mat-icon-button
            type="button"
            [attr.aria-label]="'customers.ui.chiudi' | transloco"
            class="close-button"
            (click)="onClose()"
        >
            <i class="fa-regular fa-xmark"></i>
        </button>
    </h2>

    <mat-dialog-content class="content" [formGroup]="filterForm">
        <mat-form-field appearance="outline">
            <mat-label>{{ 'customers.ui.tipoZona' | transloco }}</mat-label>
            <input matInput formControlName="tipoZona" [matAutocomplete]="autoTipoZona" [placeholder]="'customers.ui.tutti' | transloco">
            <i matSuffix class="fa-regular fa-chevron-down icon-suffix"></i>
            <mat-autocomplete #autoTipoZona="matAutocomplete" (optionSelected)="onTipoZonaSelected($event.option.value)">
                @for (opt of filteredTipoZona | async; track opt.id) {
                    <mat-option [value]="opt">{{ opt.descrizione }}</mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{ 'customers.ui.zona' | transloco }}</mat-label>
            <input matInput formControlName="zona" [matAutocomplete]="autoZona" [placeholder]="'customers.ui.zona' | transloco">
            <i matSuffix class="fa-regular fa-chevron-down icon-suffix"></i>
            <mat-autocomplete #autoZona="matAutocomplete" (optionSelected)="onZonaSelected($event.option.value)">
                @for (opt of filteredZona | async; track opt) {
                    <mat-option [value]="opt">{{ opt.nome }}</mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{ 'customers.ui.dataUltimaFattura' | transloco }}</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="dataUltimaFattura" [placeholder]="'customers.ui.datePlaceholder' | transloco">
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        @if (dialogData.options.agente.length) {
            <mat-form-field appearance="outline">
                <mat-label>{{ 'customers.ui.agente' | transloco }}</mat-label>
                <input matInput formControlName="agente" [matAutocomplete]="autoAgente" [placeholder]="'customers.ui.tutti' | transloco">
                <i matSuffix class="fa-regular fa-chevron-down icon-suffix"></i>
                <mat-autocomplete #autoAgente="matAutocomplete" (optionSelected)="onAgenteSelected($event.option.value)">
                    @for (opt of filteredAgente | async; track opt.value) {
                        <mat-option [value]="opt">{{ opt.label }}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        }

        @if (dialogData.options.ispettore.length) {
            <mat-form-field appearance="outline">
                <mat-label>{{ 'customers.ui.ispettore' | transloco }}</mat-label>
                <input matInput formControlName="ispettore" [matAutocomplete]="autoIspettore" [placeholder]="'customers.ui.tutti' | transloco">
                <i matSuffix class="fa-regular fa-chevron-down icon-suffix"></i>
                <mat-autocomplete #autoIspettore="matAutocomplete" (optionSelected)="onIspettoreSelected($event.option.value)">
                    @for (opt of filteredIspettore | async; track opt.value) {
                        <mat-option [value]="opt">{{ opt.label }}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        }

        <mat-checkbox formControlName="newCustomer">{{ 'customers.ui.clienteNuovo' | transloco }}</mat-checkbox>
    </mat-dialog-content>

    <mat-dialog-actions class="buttons-container">
        <button matButton (click)="onCancelFilter()">{{ 'customers.ui.cancella' | transloco }}</button>

        <button matButton="filled" (click)="onConfirmFilter()">{{ 'customers.ui.applica' | transloco }}</button>
    </mat-dialog-actions>
</ng-container>
